import React from "react";

import { ServiceTimeSection } from "./ServiceTimeSection/ServiceTimeSection";
import { DumpWeightSection } from "./DumpWeightSection/DumpWeightSection";
import { DailyWorkTimeCapSection } from "./DailyWorkTimeCapSection/DailyWorkTimeCapSection";
import "./RouteOptimizationTab.scss";

export function RouteOptimizationTab() {
  return (
    <div className="tab-content route-optimization-tab">
      <div className="ro-header">
        <h2>Route Optimization</h2>
        <p className="ro-subtitle">
          Tune how routes are planned. These settings feed the route optimizer.
        </p>
      </div>

      <ServiceTimeSection />
      <DailyWorkTimeCapSection />
      <DumpWeightSection />
    </div>
  );
}
